"use client";
import { SlotTableLegendProps } from "../availabilities/types";
import { SlotComponent } from "./slot-component";

export function SlotTableLegend({ children, items }: SlotTableLegendProps) {
	return (
		<div className="mt-2 flex flex-col justify-center items-center w-full gap-2 sm:justify-end">
			<div className="flex flex-row flex-wrap gap-2 max-w-full">
				{items.map(el => (
					<div key={el.title} className="flex items-center justify-end gap-2 w-full sm:w-auto sm:flex-1">
						<div
							className={`h-6 flex-1 rounded-full bg-gray-200 flex items-center flex-shrink-0 relative min-w-[200px]
							${el.selectedCounterSlots && el.selectedSlot ? "justify-between" : el.selectedCounterSlots ? "justify-start" : el.selectedSlot ? "justify-end" : "justify-center"}`}
						>
							<SlotComponent {...el} slotValue={new Date()} />
						</div>
						<div className="text-xs w-24 lg:w-32 truncate sm:whitespace-nowrap">{el.title}</div>
					</div>
				))}
			</div>
			{children}
		</div>
	);
}
